import FeatureFlag from "../types/feature-flags/featureFlag";
import { getApi, putApi } from "./helpers/apiMethods";
import ApiErrors, { handleApiError } from "./helpers/errorHandling";

const path = "feature-flags";

export type GetFeatureFlagRequest = {
  customerId: string;
  featureName: string;
};

export type GetFeatureFlagsResponse = {
  featureFlags: FeatureFlag[];
  errors: ApiErrors;
};

export type EditFeatureFlagResponse = {
  featureFlag?: FeatureFlag;
  errors: ApiErrors;
};

export type FeatureFlagFormValues = {
  isEnabled: boolean | null;
  expiration?: string | null;
};

export const DEFAULT_FEATURE_FORM_VALUES: FeatureFlagFormValues = {
  isEnabled: null,
  expiration: null,
};

export interface EditFeatureFlagRequest extends FeatureFlagFormValues {
  customerId: string;
  featureName: string;
}

export const getFeatureFlag = async (
  customerId: string,
  featureName: string
): Promise<FeatureFlag | undefined> => {
  const response = await getApi<FeatureFlag>(
    `/v1/customers/${path}/${customerId}/${featureName}`
  );
  return response.data;
};

export const getFeatureFlagByCustomer = async (
  customerId: string
): Promise<GetFeatureFlagsResponse> => {
  try {
    type Response = { featureFlags: FeatureFlag[] };
    const response = await getApi<Response>(`/v1/${path}/${customerId}`);
    const featureFlags: FeatureFlag[] = response.data?.featureFlags ?? [];
    return { featureFlags, errors: new ApiErrors() };
  } catch (error: unknown) {
    const errorMessage = handleApiError(error);
    return { featureFlags: [], errors: errorMessage };
  }
};

export const getFeatureFlagsByFeature = async (
  featureName: string
): Promise<GetFeatureFlagsResponse> => {
   try {
     type Response = { featureFlags: FeatureFlag[] };
     const response = await getApi<Response>(`/v1/${path}/${featureName}`);
     const featureFlags: FeatureFlag[] = response.data?.featureFlags ?? [];
     return { featureFlags, errors: new ApiErrors() };
   } catch (error: unknown) {
     const errorMessage = handleApiError(error);
     return { featureFlags: [], errors: errorMessage };
   }
}

export const getFeatureFlags = async (): Promise<GetFeatureFlagsResponse> => {
  try {
    type Response = { featureFlags: FeatureFlag[] };
    const response = await getApi<Response>(`/v1/${path}`);
    const featureFlags: FeatureFlag[] = response.data?.featureFlags ?? [];
    return { featureFlags, errors: new ApiErrors() };
  } catch (error: unknown) {
    const errorMessage = handleApiError(error);
    return { featureFlags: [], errors: errorMessage };
  }
};

export const editFeatureFlag = async ({
  customerId,
  ...request
}: EditFeatureFlagRequest): Promise<EditFeatureFlagResponse> => {
  try {
    const response = await putApi<FeatureFlag, FeatureFlagFormValues>(
      `/v1/${path}/${customerId}`,
      request
    );
    const featureFlag: FeatureFlag | undefined = response.data;
    return { featureFlag, errors: new ApiErrors() };
  } catch (error: unknown) {
    const errors = handleApiError(error);
    return { errors };
  }
};
